module.exports = __webpack_public_path__ + "static/media/pause.f87fdb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/pause.png
// module id = 556
// module chunks = 6